import {
  USER_STATUS,
  IUserStatusItem,
  IUserPermissionsItem,
  USER_PERMISSIONS,
  IRedirectDefaultItem,
} from "@core/entities";

export * from "./microfront.constants";
export * from "./styles.constants";

export const localStorageKey = "app_storage";

export const USER_PERMISSIONS_DATA: IUserPermissionsItem[] = [
  {
    value: USER_PERMISSIONS.FAKEORDER_ACCESS,
    label: "Operador Fake Order",
  },
  {
    value: USER_PERMISSIONS.EDIT_USER,
    label: "Editar Usuario",
  },
  {
    value: USER_PERMISSIONS.SUPPLIER_ACCESS,
    label: "Operador Supplier",
  },
  {
    value: USER_PERMISSIONS.FINANCIAL_ACCESS,
    label: "Administración financiera",
  },
  {
    value: USER_PERMISSIONS.PROMOTION_MARKDOWNS,
    label: "Promotion",
  },
  {
    value: USER_PERMISSIONS.PROMOTION_ACCESS,
    label: "Promotion",
  },
  {
    value: USER_PERMISSIONS.COMPETITIVE_PRICE_ACCESS,
    label: "Competitive Price",
  },
  {
    value: USER_PERMISSIONS.CHARM_PRICE_ACCESS,
    label: "Charm Price",
  },
  {
    value: USER_PERMISSIONS.BULK_UPLOAD_ACCESS,
    label: "Bulk Upload",
  },
  {
    value: USER_PERMISSIONS.CHARM_PRICE_ACCESS,
    label: "Charm Price",
  },
  {
    value: USER_PERMISSIONS.SELL_PRICES_ACCESS,
    label: "Sell Prices",
  },
  {
    value: USER_PERMISSIONS.WISHLIST_ACCESS,
    label: "Wishlist",
  },
  {
    value: USER_PERMISSIONS.PACKS_ACCESS,
    label: "Packs",
  },
  {
    value: USER_PERMISSIONS.LABEL_ACCESS,
    label: "Etiquetas",
  },
  {
    value: USER_PERMISSIONS.PRICING_ACCESS,
    label: "Pricing",
  },
  {
    value: USER_PERMISSIONS.MARKUP_ACCESS,
    label: "Markup",
  },
  {
    value: USER_PERMISSIONS.ROTATION_MANAGER_ACCESS,
    label: "Rotation Manager",
  },
  {
    value: USER_PERMISSIONS.COMPLEX_DISCOUNT_ACCESS,
    label: "Complex Discount",
  },
  {
    value: USER_PERMISSIONS.ALL_SUPPLIER_ACCESS,
    label: "User with all suppliers",
  },
];

export const USER_STATUS_DATA: IUserStatusItem[] = [
  {
    value: USER_STATUS.ACTIVE,
    label: "Usuarios Activos",
  },
  {
    value: USER_STATUS.INACTIVE,
    label: "Usuarios Inactivos",
  },
];

export const LOGOUT_MESSAGE =
  "Debes verificar tu correo antes de ingresar a Turbo WMS. Por favor, busca en tu casilla el correo de verificación que te hemos enviado al registrar la cuenta.";
